import React from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import AllPromoCodes from "./all-promo-codes";
import PromoCodeUpdate from "./promo-code-update";
import PromoCodeUsed from "./promo-code-usage";

const PromoCode = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "AUDITOR_PROMO_CODE",
      "AUDITOR_PROMO_CODE"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("ALL_PROMO_CODES")}
        subTitle={i18n.get("ALL_PROMO_CODES")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <AllPromoCodes />
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <Et3PageTitle
        title={i18n.get("UPDATE_PROMO_CODE")}
        subTitle={i18n.get("UPDATE_PROMO_CODE")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <PromoCodeUpdate />
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <Et3PageTitle
        title={i18n.get("PROMO_CODE_USAGE")}
        subTitle={i18n.get("PROMO_CODE_USAGE")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <PromoCodeUsed />
    </ET3PageDiv>
  );
});
export default PromoCode;
